import { appointmentConst } from '../constants/Appointments.const';

export const getRedemptionBranchAuthorization = (response) => {
  const detail = response?.data?.message;

  return detail?.code ===
    appointmentConst.REDEMPTION_BRANCH.AUTHORIZATION_REQUIRED
    ? detail
    : null;
};

export const getLocalRedemptionBranchAuthorization = ({
  appointment,
  purchasedProducts,
  branches,
}) => {
  if (!appointment?.purchasedProductId || !appointment?.branchId) return null;

  const purchasedProduct = purchasedProducts?.find(
    ({ id }) => id === appointment.purchasedProductId
  );
  const responsibleBranch = purchasedProduct?.responsibleRedemptionBranch;

  if (!responsibleBranch || responsibleBranch.id === appointment.branchId)
    return null;

  const destinationBranch = branches?.find(
    ({ id }) => id === appointment.branchId
  );

  return {
    code: appointmentConst.REDEMPTION_BRANCH.AUTHORIZATION_REQUIRED,
    order: purchasedProduct.order,
    treatment: purchasedProduct.treatment,
    responsibleBranch,
    destinationBranch: destinationBranch || { id: appointment.branchId },
  };
};
